import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Linked Service',
  path: '/homenet/linkedService',
  redirect: '/homenet/linkedService/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'Linked Service List',
      'path': 'list',
      'meta': {
        'label': 'List'
      },
      'component': lazyLoading('homenet/LinkedServiceList')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/linkedService.js